<template>
  <div
    v-if="state"
    class="clear-refinements"
  >
    <slot
      :can-refine="canRefine"
      :refine="state.refine"
      :create-url="state.createURL"
    >
      <Button
        v-if="canRefine"
        class="clear-btn"
        size="sm"
        variant="text"
        type="reset"
        start-icon="mono-delete"
        :disabled="!canRefine"
        @click.prevent="state.refine"
      >
        <Tooltip type="negative">
          {{ t('Tools.clearAll.tooltip') }}
        </Tooltip>
      </Button>
    </slot>
  </div>
</template>

<script setup>
import { inject, ref, computed, watch } from 'vue'
import { useConnector } from '@/composables'
import { connectClearRefinements } from 'instantsearch.js/es/connectors'
import { useTranslation } from 'i18next-vue'

defineOptions({ name: 'ClearRefinements' })
const props = defineProps({
  excludedAttributes: { type: Array, default: undefined },
  includedAttributes: { type: Array, default: undefined },
  transformItems: { type: Function, default: undefined }
})

const $emitter = inject('instantSearchPanelEmitter', { emit: () => {} })

const state = useConnector(connectClearRefinements, {
  $$widgetType: 'ais.clearRefinements',
  includedAttributes: props.includedAttributes,
  excludedAttributes: props.excludedAttributes,
  transformItems: props.transformItems
})
const { t } = useTranslation('filters')

const hasEmitted = ref(false)

const canRefine = computed(() => state.value.hasRefinements)

const mapStateToCanRefine = s => !!s.canRefine

watch(() => state.value, (newState, oldState) => {
  if (!newState) return

  const previousCanRefine = mapStateToCanRefine(oldState || {})
  const nextCanRefine = mapStateToCanRefine(newState)

  // console.log('%cstate', 'color:orange', newState.items.filter(i => i.isRefined).map(i => i.value))

  if (!hasEmitted.value || previousCanRefine !== nextCanRefine) {
    $emitter.emit('PANEL_CHANGE_EVENT', nextCanRefine)
    hasEmitted.value = true
  }
}, { immediate: true })
</script>

<style scoped>
@reference "#app-styles.css";

.clear-refinements {
  @apply flex items-center;

  .clear-btn { @apply hover:text-negative-mid!; }
}
</style>
